<template lang="pug">
  div(class="templates-autocomplete-preview")
    div(class="templates-autocomplete-preview__image")
      v-img(
        :src="require('~/assets/images/autocomplete-banner.png')"
        width="100%"
        height="200"
      )
    div(class="templates-autocomplete-preview__content")
      h2(class="title-32px bold pb-2") {{ $t('Autofill data') }}
      div(class="text-16px pb-6") {{ $t('Get accurate data without typos errors, get them from Diia or BankID') }}
      div(class="text-14px dark pb-2") ✔ {{ $t('You activate autofill for the fields you need') }}
      div(class="text-14px dark pb-2") ✔ {{ $t('The recipient fills in the official data in just 30 seconds and without errors') }}
      div(class="text-14px dark") ✔ {{ $t('Available only for text fields') }}
      div(class="two-buttons-wrapper pt-8")
        v-btn(
          height="48"
          @click="handleClose"
        ) {{ $t('Next time') }}
        v-btn(
          class="main-button"
          @click="tryAutocomplete"
        ) {{ $t('Try autocomplete') }}
</template>

<script>
import { driver } from 'driver.js'
import { TYPES } from '~/modules/templates/constants/fields'

export default {
  name: 'BlockTemplatesAutocompletePreview',
  props: {
    closeModal: {
      type: Function,
      default: null
    }
  },
  methods: {
    handleClose() {
      this.$setLocalStorageClientData({ showAutocompleteModal: false })
      this.closeModal()
    },
    async tryAutocomplete() {
      this.closeModal()
      this.$setLocalStorageClientData({ showAutocompleteModal: false })
      const createdTextField = await this.$store.dispatch('templatefields/createField', {
        type: TYPES.text,
        page: 1,
        overrides: {
          positionY: 200
        }
      })
      this.$store.commit('templatefields/SET_TOOLBARS_MAP_FIELD_ID', {
        id: createdTextField.id,
        value: true
      })
      this.$nextTick(() => {
        this.showAutocompleteTour()
      })
    },
    showAutocompleteTour() {
      driver({
        showProgress: false,
        overlayOpacity: 0,
        allowClose: false,
        doneBtnText: 'Зрозуміло',
        showButtons: ['next'],
        steps: [
          {
            element: '#toolbar-autocomplete-toggle-button',
            popover: {
              title: 'Активуйте автозаповнення',
              description: `Отримуйте точні перевірені дані без помилок введення через Дія або BankID\n
                \nАвтозаповнення полів: ПІБ, Дата народження, Місце народження, РНОКПП (ІПН)`,
              side: 'top',
              align: 'center'
            }
          }
        ]
      }).drive()
    }
  }
}
</script>

<style scoped lang="scss">
.templates-autocomplete-preview {
  &__content {
    padding: 32px 40px 40px 40px;
  }
}
</style>
